<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useRoute } from "vue-router"
import { useHomeysIframe } from "@core/composables"
import LayoutBlank from "@core/layouts/LayoutBlank.vue"
import LayoutHeader from "@core/layouts/LayoutHeader.vue"
import LayoutWithSidebar from "@core/layouts/LayoutWithSidebar.vue"

// ================================
// LAYOUT RÉSOLU DEPUIS META
// ================================
const route = useRoute()
const { isHomeysIframe } = useHomeysIframe()

const layoutType = computed(() => {
    if (isHomeysIframe.value && route.name === "PageBuildingData") {
        return "blank"
    }
    const meta = route.meta
    const layout = meta.layout as string | undefined
    return layout === "blank" ||
        layout === "header" ||
        layout === "header-sidebar"
        ? layout
        : "header"
})

const LayoutComponent = computed(() => {
    switch (layoutType.value) {
        case "blank":
            return LayoutBlank
        case "header-sidebar":
            return LayoutWithSidebar
        default:
            return LayoutHeader
    }
})
</script>

<template>
    <component :is="LayoutComponent" />
</template>
